import useMutationApi, {
  MutationApiOptions,
  MutationApiResult,
  MutationMutatorRequesterResult,
} from './hooks/useMutationApi';
import useObjectApi, {
  ObjectApiOptions,
  ObjectApiResult,
} from './hooks/useObjectApi';
import useObjectListApi, {
  ObjectListApiOptions,
  ObjectListApiResult,
} from './hooks/useObjectListApi';
import usePaginatedApi, {
  PaginatedApiOptions,
  PaginatedApiResult,
} from './hooks/usePaginatedApi';
import usePaginatedTokenApi, {
  PaginatedTokenApiOptions,
  PaginatedTokenApiResult,
} from './hooks/usePaginatedTokenApi';

// Export hooks
export {
  useMutationApi,
  useObjectApi,
  useObjectListApi,
  usePaginatedApi,
  usePaginatedTokenApi,
};

// Export types
export type {
  MutationApiOptions,
  MutationApiResult,
  MutationMutatorRequesterResult,
  ObjectApiOptions,
  ObjectApiResult,
  ObjectListApiOptions,
  ObjectListApiResult,
  PaginatedApiOptions,
  PaginatedApiResult,
  PaginatedTokenApiOptions,
  PaginatedTokenApiResult,
};
